// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mote-marker-container {
  position: absolute;
  display: flex;
  font-family: var(--text-font);
  text-shadow: none;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none !important;
  z-index: 1;
  overflow: visible;
  box-sizing: border-box;
  cursor: pointer;
}
.mote-marker-container.hide {
  opacity: 0;
}
.mote-marker-container .marker {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: inherit;
  height: inherit;
  margin: auto;
  border-radius: 100%;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: auto;
  transform: scale(0.25);
  transition: transform 0.2s;
}
.mote-marker-container .marker:hover {
  transform: scale(0.28);
}
.mote-marker-container .marker-image {
  position: absolute;
  overflow: hidden;
  height: 86%;
  width: 86%;
  border-radius: 100%;
  box-sizing: border-box;
  user-select: none;
  -webkit-user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mote-marker-container .marker-image img {
  position: absolute;
  overflow: hidden;
  height: 100%;
  width: 100%;
  border-radius: 100%;
}
.mote-marker-container .marker-image .marker-overlay {
  background: rgba(0, 0, 0, 0.3);
  color: var(--motes-white);
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 68px;
  font-weight: bold;
  border-radius: 100%;
  display: none;
}
.mote-marker-container .marker-image .square-overlay {
  opacity: 0;
}
.mote-marker-container .marker-image .square-overlay.fade-in {
  opacity: 1;
  transition: 0.2s;
}
.mote-marker-container .marker-border {
  height: 100%;
  width: 100%;
  border-radius: 100%;
  background: var(--motes-white);
  box-shadow: 0px 4px 5px 0px rgba(34, 34, 34, 0.16);
}
.mote-marker-container .marker-glow {
  position: absolute;
  height: 150%;
  width: 150%;
  border-radius: 100%;
  display: none;
  pointer-events: none;
}
.mote-marker-container .marker-glow:before {
  content: "";
  display: block;
  width: 200%;
  height: 200%;
  box-sizing: border-box;
  margin-left: -50%;
  margin-top: -50%;
  border-radius: 100%;
  background: linear-gradient(180deg, #FFDC8B 0%, #EFBE61 100%);
  animation: pulse-glow 1.4s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}
.mote-marker-container:not(.loaded) .marker-image img {
  opacity: 0;
}
.mote-marker-container:not(.loaded) .marker-border, .mote-marker-container:not(.loaded) .marker-overlay {
  opacity: 1;
  background-color: var(--motes-darker-gray);
}
.mote-marker-container:not(.loaded) .marker-border {
  border: 16px solid var(--motes-white);
  box-sizing: border-box;
}
.mote-marker-container.loaded .marker-image img {
  opacity: 1;
  transition: 0.5s opacity;
}
.mote-marker-container.loaded .marker-image.img-missing {
  background: var(--upload-background-gradient);
}
.mote-marker-container.unlocked .marker-border {
  background: var(--primary-color);
}
.mote-marker-container.available .marker-border {
  background: var(--upload-background-gradient);
  animation: pulse-img 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
}
.mote-marker-container.available .marker-glow {
  display: block;
}
.mote-marker-container.available .marker-image {
  animation: pulse-img 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
}
.mote-marker-container.unlocking {
  z-index: 3;
}
.mote-marker-container.unlocking .marker {
  animation: unlock-expand 1.5s ease forwards;
}
.mote-marker-container.unlocking .marker .marker-overlay {
  animation: 0.5s shrink-overlay 1.2s ease-in forwards;
}
.mote-marker-container.unlocking .marker .marker-border {
  background: var(--upload-background-gradient);
  animation: initial;
}
.mote-marker-container.unlocking .marker .marker-glow {
  display: block;
}
.mote-marker-container.unlocking .marker .marker-glow::before {
  animation: dissolve-glow 1.8s ease-out forwards;
}
.mote-marker-container.unlocking .marker .marker-image {
  animation: initial;
  transition: 0.2s;
  height: 90%;
  width: 90%;
}
.mote-marker-container.edit .marker-overlay, .mote-marker-container.locked .marker-overlay, .mote-marker-container.unlocking .marker-overlay, .mote-marker-container.available .marker-overlay {
  display: flex;
}
.mote-marker-container.active:not(.unlocking) {
  z-index: 2;
}
.mote-marker-container.active.tour .marker-border {
  background-color: var(--primary-color);
}
.mote-marker-container.active.edit .marker-border {
  background: var(--tertiary-color);
}
.mote-marker-container.active:not(.edit) .marker {
  transform: scale(0.35);
}
.mote-marker-container.directions-shown .marker-border, .mote-marker-container.directions-shown .marker-image {
  animation: pulse-img-slight 1.8s cubic-bezier(0.47, 0, 0.62, 0.77) -0.4s infinite;
}
@keyframes pulse-img-slight {
  0% {
    transform: scale(0.93);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.93);
  }
}
@keyframes pulse-img {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}
@keyframes pulse-glow {
  0% {
    transform: scale(0.33);
  }
  80%, 100% {
    opacity: 0;
  }
}
@keyframes dissolve-glow {
  0% {
    transform: scale(0.33);
  }
  50% {
    opacity: 0.3;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
}
@keyframes shrink-overlay {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes unlock-expand {
  0% {
    transform: scale(0.25);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/mote-map-marker/mote-map-marker.component.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EAGA,+BAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AALJ;AAOI;EACI,UAAA;AALR;AAQI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAnCQ;EAoCR,0BAAA;AANR;AAQQ;EACI,sBAtCE;AAgCd;AAUI;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARR;AAUQ;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AARZ;AAWQ;EACI,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AATZ;AAYQ;EACI,UAAA;AAVZ;AAYY;EACI,UAAA;EACA,gBAAA;AAVhB;AAeI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,kDAAA;AAbR;AAgBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAdR;AAgBQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6DAAA;EACA,uEAAA;AAdZ;AAmBQ;EACI,UAAA;AAjBZ;AAoBQ;EACI,UAAA;EACA,0CAAA;AAlBZ;AAqBQ;EACI,qCAAA;EACA,sBAAA;AAnBZ;AAwBQ;EACI,UAAA;EACA,wBAAA;AAtBZ;AAyBQ;EACI,6CAAA;AAvBZ;AA6BQ;EACI,gCAAA;AA3BZ;AAiCQ;EACI,6CAAA;EACA,gFAAA;AA/BZ;AAkCQ;EACI,cAAA;AAhCZ;AAmCQ;EACI,gFAAA;AAjCZ;AAqCI;EACI,UAAA;AAnCR;AAqCQ;EACI,2CAAA;AAnCZ;AAqCY;EACI,oDAAA;AAnChB;AAsCY;EACI,6CAAA;EACA,kBAAA;AApChB;AAuCY;EACI,cAAA;AArChB;AAuCgB;EACI,+CAAA;AArCpB;AAyCY;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAvChB;AA6CQ;EACI,aAAA;AA3CZ;AAiDQ;EACI,UAAA;AA/CZ;AAkDQ;EACI,sCAAA;AAhDZ;AAmDQ;EACI,iCAAA;AAjDZ;AAoDQ;EACI,sBA3NG;AAyKf;AAuDQ;EACI,iFAAA;AArDZ;AAyDI;EACI;IACI,sBAAA;EAvDV;EAyDM;IACI,mBAAA;EAvDV;EAyDM;IACI,sBAAA;EAvDV;AACF;AA0DI;EACI;IACI,qBAAA;EAxDV;EA0DM;IACI,mBAAA;EAxDV;EA0DM;IACI,qBAAA;EAxDV;AACF;AA2DI;EACI;IACI,sBAAA;EAzDV;EA2DM;IACI,UAAA;EAzDV;AACF;AA4DI;EACI;IACI,sBAAA;EA1DV;EA4DM;IACI,YAAA;EA1DV;EA4DM;IACI,mBAAA;IACA,UAAA;EA1DV;AACF;AA6DI;EACI;IACI,mBAAA;EA3DV;EA6DM;IACI,mBAAA;EA3DV;AACF;AA8DI;EACI;IACI,sBAhSI;EAoOd;EA8DM;IACI,mBAAA;EA5DV;AACF","sourcesContent":["$initial-scale: scale(0.25);\n$hover-scale: scale(0.28);\n$active-scale: scale(0.35);\n\n.mote-marker-container  {\n    position: absolute;\n    display: flex;\n    font-family: var(--text-font);\n    text-shadow: none;\n    user-select: none;\n    -webkit-user-select: none;\n    // OBS: Mapbox will set 'pointer-events: auto' directly on the element \n    // so important is needed here (fixes blocking pointer events on neighbor markers)\n    pointer-events: none !important;\n    z-index: 1;\n    overflow: visible;\n    box-sizing: border-box;\n    cursor: pointer;\n\n    &.hide {\n        opacity: 0;\n    }\n\n    .marker {\n        position:absolute;\n        display:flex;\n        align-items: center;\n        justify-content: center;\n        width: inherit;\n        height: inherit;\n        margin: auto;\n        border-radius: 100%;\n        user-select: none;\n        -webkit-user-select: none;\n        pointer-events: auto;\n        transform: $initial-scale;\n        transition: transform 0.2s;\n\n        &:hover {\n            transform: $hover-scale;\n        }\n    }\n\n    .marker-image {\n        position: absolute;\n        overflow: hidden;\n        height: 86%;\n        width: 86%;\n        border-radius: 100%;\n        box-sizing: border-box;\n        user-select: none;\n        -webkit-user-select: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img {\n            position: absolute;\n            overflow: hidden;\n            height: 100%;\n            width: 100%;\n            border-radius: 100%;\n        }\n\n        .marker-overlay {\n            background: rgba(0, 0, 0, 0.3);\n            color: var(--motes-white);\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n            font-size: 68px;\n            font-weight: bold;\n            border-radius: 100%;\n            display: none;\n        }\n\n        .square-overlay {\n            opacity: 0;\n\n            &.fade-in {\n                opacity: 1;\n                transition: 0.2s;\n            }\n        }\n    }\n\n    .marker-border {\n        height: 100%;\n        width: 100%;\n        border-radius: 100%;\n        background: var(--motes-white);\n        box-shadow: 0px 4px 5px 0px rgb(34 34 34 / 16%);\n    }\n\n    .marker-glow {\n        position: absolute;\n        height: 150%;\n        width: 150%;\n        border-radius: 100%;\n        display: none;\n        pointer-events: none;\n\n        &:before {\n            content: \"\";\n            display: block;\n            width: 200%;\n            height: 200%;\n            box-sizing: border-box;\n            margin-left: -50%;\n            margin-top: -50%;\n            border-radius: 100%;\n            background: linear-gradient(180deg, #FFDC8B 0%, #EFBE61 100%);\n            animation: pulse-glow 1.4s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;\n        }\n    }\n\n    &:not(.loaded) {\n        .marker-image img {\n            opacity: 0;\n        }\n\n        .marker-border, .marker-overlay {\n            opacity: 1;\n            background-color: var(--motes-darker-gray);\n        }\n\n        .marker-border {\n            border: 16px solid var(--motes-white);\n            box-sizing: border-box;\n        }\n    }\n\n    &.loaded {\n        .marker-image img {\n            opacity: 1;\n            transition: 0.5s opacity;\n        }\n\n        .marker-image.img-missing {\n            background: var(--upload-background-gradient);\n        }\n    }\n\n    &.unlocked {\n\n        .marker-border {\n            background: var(--primary-color);\n        }\n    }\n\n    &.available {\n\n        .marker-border {\n            background: var(--upload-background-gradient);\n            animation: pulse-img 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;\n        }\n\n        .marker-glow {\n            display: block;\n        }\n\n        .marker-image {\n            animation: pulse-img 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;\n        }\n    }\n\n    &.unlocking {\n        z-index: 3;\n\n        .marker {\n            animation: unlock-expand 1.5s ease forwards;\n\n            .marker-overlay {\n                animation: 0.5s shrink-overlay 1.2s ease-in forwards;\n            }\n\n            .marker-border {\n                background: var(--upload-background-gradient);\n                animation: initial;\n            }\n\n            .marker-glow {\n                display: block;\n\n                &::before {\n                    animation: dissolve-glow 1.8s ease-out forwards\n                }\n            }\n\n            .marker-image {\n                animation: initial;\n                transition: 0.2s;\n                height: 90%;\n                width: 90%;\n            }\n        }\n    }\n\n    &.edit, &.locked, &.unlocking, &.available {\n        .marker-overlay {\n            display: flex;\n        }\n    }\n    \n    &.active {\n\n        &:not(.unlocking) {\n            z-index: 2;\n        }\n\n        &.tour .marker-border {\n            background-color: var(--primary-color);\n        }\n\n        &.edit .marker-border {\n            background: var(--tertiary-color);\n        }\n    \n        &:not(.edit) .marker {\n            transform: $active-scale;\n        }\n    }\n\n    &.directions-shown {\n        .marker-border, .marker-image {\n            animation: pulse-img-slight 1.8s cubic-bezier(0.47, 0, 0.62, 0.77) -0.4s infinite;\n        }\n    }\n\n    @keyframes pulse-img-slight {\n        0% {\n            transform: scale(.93);\n        }\n        50% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(.93);\n        }\n    }\n\n    @keyframes pulse-img {\n        0% {\n            transform: scale(.8);\n        }\n        50% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(.8);\n        }\n    }\n\n    @keyframes pulse-glow {\n        0% {\n            transform: scale(.33);\n        }\n        80%, 100% {\n            opacity: 0;\n        }\n    }\n\n    @keyframes dissolve-glow {\n        0% {\n            transform: scale(.33);\n        }\n        50% {\n            opacity: 0.3;\n        }\n        100% {\n            transform: scale(3);\n            opacity: 0;\n        }\n    }\n\n    @keyframes shrink-overlay {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n\n    @keyframes unlock-expand {\n        0% {\n            transform: $initial-scale;\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
